import React from 'react';
export function Footer() {
  return <footer className="bg-cream-100 py-10 px-5 sm:px-6 border-t border-cream-300" data-id="element-84" data-mp="32wd2qgad7ltj">
      <div className="max-w-3xl mx-auto text-center" data-id="element-85" data-mp="3gg0yw2enzvx4">
        <div className="inline-flex items-center gap-2" data-id="element-86" data-mp="32o4bucrusc7l">
          <span className="text-xl" aria-hidden="true" data-id="element-87" data-mp="32pfci3q053uh">⭐</span>
          <span className="text-rose-600 font-bold tracking-widest uppercase" data-id="element-88" data-mp="36oo9dhgc9hu9">
            PUNTO DIGITAL™
          </span>
        </div>
        <p className="text-sm text-ink-muted leading-snug mt-2 max-w-xl mx-auto" data-id="element-89" data-mp="3uftn9r2py01x">
          Material práctico, visual e imprimible para acompañar el aprendizaje
          de la lectura desde casa siguiendo un recorrido progresivo de
          sílabas, palabras, frases, comprensión e historias.
        </p>
        <p className="font-serif text-[15px] text-rose-700 leading-snug mt-3 max-w-xl mx-auto" data-id="element-90" data-mp="3qblyxv06am48">
          “Porque aprender a leer no debería significar frustrarse frente a
          ejercicios sueltos sin saber qué hacer después.”
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-3 gap-y-1 text-sm text-ink-muted mt-4" data-id="element-91" data-mp="3l90l3octskvk">
          <a href="mailto:supportpuntodigital@gmail.com" className="hover:text-rose-600 transition-colors" data-id="element-92" data-mp="3gb8ses4cwuqb">
            📧 supportpuntodigital@gmail.com
          </a>
          <span className="text-rose-300" aria-hidden="true" data-id="element-93" data-mp="3q8n0a3c7sb70">•</span>
          <a href="https://www.puntodigital.store" className="hover:text-rose-600 transition-colors" data-id="element-94" data-mp="3q7bww4mol5gf">
            🌐 www.puntodigital.store
          </a>
        </div>

        <hr className="w-[82%] mx-auto my-5 border-t border-rose-200" data-id="element-95" data-mp="32w3duq73ebb" />

        <p className="text-xs text-ink-soft" data-id="element-96" data-mp="hsk0skv99str">
          © Punto Digital™ 2026 — Todos los derechos reservados.
        </p>
        <p className="text-[11px] text-ink-soft mt-1" data-id="element-97" data-mp="curzx1cmuwdf">
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-[11px] text-ink-muted leading-relaxed mt-5 max-w-lg mx-auto" data-id="element-98" data-mp="qr5ikdswl3th">
          <span className="font-bold" data-id="element-99" data-mp="mptptzeqg2h2">AVISO:</span> Este material tiene fines
          educativos y de acompañamiento en el hogar. No sustituye la
          evaluación ni intervención de docentes, psicopedagogos,
          fonoaudiólogos u otros profesionales cuando sean necesarias.
        </p>
      </div>
    </footer>;
}